<template>
  <div class="payment-status">
    <base-loader></base-loader>
  </div>
</template>

<script>
import { OrderApi } from "@/office/order/order-api";
import BaseLoader from "@/components/base/BaseLoader";

export default {
  name: "PaymentStatus",
  components: { BaseLoader },
  props: ["id"],
  data() {
    return {
      order: null,
      receiptLoading: false,
    };
  },
  async created() {
    await this.loadOrder();
  },
  computed: {},
  methods: {
    async loadOrder() {
      try {
        let orderResponse = await new OrderApi().loadOrder(this.id, 1);
        this.order = orderResponse.data.order;

        if (this.order.status === "paid") {
          await this.$router.push(`/order/${this.order.id}/success`);
        } else if (this.order.status === "pending") {
          setTimeout(async () => {
            let orderResponse = await new OrderApi().loadOrder(this.id, 1);
            this.order = orderResponse.data.order;

            if (this.order.status === "paid") {
              await this.$router.push(`/order/${this.order.id}/success`);
            } else if (this.order.status === "pending") {
              await this.$router.push(`/order/${this.order.id}/pending`);
            } else {
              await this.$router.push(`/order/${this.order.id}/error`);
            }
          }, 5000);
        } else {
          await this.$router.push(`/order/${this.order.id}/error`);
        }
      } catch {
        await this.$router.push("/archive");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.payment-status {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 30px;
  margin-top: -50px;

  .page {
    &__title {
      margin-bottom: 26px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: pxToRem(16);
    line-height: pxToRem(18);
    color: $action;
    margin-bottom: 20px;
  }

  &__amount {
    font-weight: bold;
    font-size: pxToRem(14);
    line-height: pxToRem(18);
    color: $text;
    margin-bottom: 35px;
  }

  &__content {
    padding: 32px;
    border-radius: 16px;
    border: 1px solid #f0f3fa;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f0f3fa;
    border-radius: 16px;
    padding: 21px 25px;
    margin-bottom: 25px;

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-right: 20px;
    }

    &-text {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &--print {
      cursor: pointer;
      transition: opacity 0.2s linear;

      &.disabled {
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .primary-button {
    margin-bottom: 10px;
  }
}
</style>
